import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resources from './locales';
export const baseI18nOptions = {
    resources,
    fallbackLng: 'en',
    ns: ['translation'],
    lowerCaseLng: true,
    defaultNS: 'translation',
    keySeparator: '.',
    interpolation: { escapeValue: false },
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(baseI18nOptions)
    .then(() => {
    // Guarded: some test/non-DOM contexts import i18n but have no `document`.
    if (typeof document !== 'undefined') {
        document.documentElement.lang = i18n.language;
    }
})
    .catch(() => {
    // i18n init + lang update is best-effort; never surface as an unhandled rejection.
});
export const setLanguage = (lang) => {
    const normalized = lang.toLowerCase();
    void i18n.changeLanguage(normalized);
    document.documentElement.lang = normalized;
};
export default i18n;
//# sourceMappingURL=i18n.js.map